import { CustomCheckbox as Checkbox } from "@/src/lib/ui";
import { HodAutocomplete as Autocomplete } from "@/src/lib/ui";
import { useSelector } from "react-redux";
import IconCode from "@/src/lib/iconCode";
import Iconify from "../../iconify/Iconify";
import { usePatientList } from "@/src/lib/module-helper/my-account/hook/useAddressQuery";
import { useEffect, useState } from "react";
import {
    clearAllCart,
    removeFromCart,
} from "@/src/lib/store/add-to-cart/slice";
import { useDispatch } from "react-redux";
import { useToast } from "@/src/lib/hooks/useToast";
// import ConfirmDialog from "../../confirm-dialog/ConfirmDialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";

import DeletePatientFromCartPopup from "./deleteTestFromCartPopup";
import { VISITTYPE } from "@/src/lib/util/config";
import { testApiService } from "@/src/lib/api-services/testApiServices";
import Progressbar from "../../loading";
// import { updateSession } from "@/src/lib/util/updateSession";
import { useRouter } from "next/router";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import useAuth from "@/src/lib/hooks/useAuth";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomButton from "@/src/lib/ui/Button";
import CustomIconButton from "@/src/lib/ui/iconButton";
import TextField from "../../custom-fields/TextField";

const PatientAddedInCart = ({ handleClose, refetchCheckoutData }) => {
    const { patientList } = usePatientList();
    const { isLoggedIn } = useAuth();
    const { refetch: isCartCountRefetch } = useCustomQuery(
        "cart_count",
        cartApiService.getCartCount,
        {
            enabled: isLoggedIn && isLoggedIn,
        }
    );

    const { push } = useRouter();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const { showCustomToast, showToast } = useToast();
    const cartInPatient = useSelector((state) => state?.addToCart?.addProducts);

    //console.log("cartInPatient======", cartInPatient);
    // const { cartDetails } = useSelector((state) => state?.user?.userInfo);

    // State to track selected members for each test item
    const [selectedMembers, setSelectedMembers] = useState([]);

    // Handle change in selected options in Autocomplete
    const handleSelectChange = (index, newValue) => {
        const updatedMembers = [...selectedMembers];
        updatedMembers[index] = newValue;
        setSelectedMembers(updatedMembers);
    };

    const { mutate, isLoading: isPending } = useHODMutation(
        (data) => testApiService.addToCentreCartPopUp(data),
        {
            onSuccess: (data, variables) => {
                dispatch(removeFromCart(variables?.variantId));
                isCartCountRefetch();
                showToast(data);
                if (cartInPatient?.centreTest.length == 1) {
                    handleClose();
                    refetchCheckoutData();
                    push("/cart");
                }
            },
            onError: (error) => {
                showToast(error);
            },
        }
    );

    // Handle Add button click
    const handleAddClick = (index, item, centreId) => {
        const selectedData = selectedMembers[index];

        const patientIds = selectedData?.map((item) => item.patientId);

        const payload = {
            productId: item?.productId,
            variantId: item?.itemId,
            itemName: item?.itemName,
            visitType: VISITTYPE.CENTRE,
            patientGuids: patientIds,
            discountRemark: "Discount",
            remark: "Remark",
            centreId: centreId,
        };

        //  console.log("selectedData", selectedData, payload);

        mutate(payload);
        // Perform actions with selectedData as needed
    };

    // remove test from cart (redux)
    const removeProductFromCart = (itemId) => {
        setOpen(itemId);
    };

    const onClose = () => {
        setOpen(false);
    };
    // REFACTOR LATER
    useEffect(() => {
        if (cartInPatient?.centreTest?.length === 0) {
            handleClose();
        }
    }, [cartInPatient]);

    // remove all the test from cart (redux)
    const clearAllCartHandler = () => {
        dispatch(clearAllCart());
        showCustomToast("All items removed from cart", "success");
    };

    const removeTest = (itemId) => {
        if (!itemId) return;
        dispatch(removeFromCart(itemId));

        showCustomToast("Test Removed Successfully", "success");
        onClose();
        if (cartInPatient?.centreTest.length == 1) {
            handleClose();
        }
    };

    return (
        <>
            <div className="p-2">
                <div className="flex flex-row justify-between items-center">
                    <h6 className="text-black text-base max-w-64 w-full font-medium">
                        Please Select Members in order to add Tests in Cart
                    </h6>

                    <CustomButton
                        variant="outlined"
                        onClick={clearAllCartHandler}
                    >
                        Delete All
                    </CustomButton>
                </div>

                {isPending ? (
                    <div className="flex justify-center items-center py-5">
                        <Progressbar />
                    </div>
                ) : (
                    cartInPatient?.centreTest?.map((item, index) => {
                        return (
                            <div className="border-b border-solid border-gray-200 py-6">
                                <div className="flex flex-row items-center mb-5">
                                    <CustomIconButton
                                        className="bg-primary/15 mr-2"
                                        onClick={() =>
                                            removeProductFromCart(item.itemId)
                                        }
                                    >
                                        <Iconify
                                            icon={IconCode.delete}
                                            className="text-primary"
                                        />
                                    </CustomIconButton>
                                    <h6 className="text-black text-base">
                                        {item.itemName}
                                    </h6>
                                </div>
                                <div className="flex flex-row justify-between items-center gap-3">
                                    <Autocomplete
                                        limitTags={2}
                                        multiple
                                        size="small"
                                        id={`checkboxes-tags-demo-${index}`}
                                        options={patientList || []}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) =>
                                            option.pName
                                        }
                                        renderOption={(
                                            props,
                                            option,
                                            { selected }
                                        ) => {
                                            const { key, ...optionProps } =
                                                props;
                                            return (
                                                <li
                                                    key={key}
                                                    {...optionProps}
                                                    className={`${
                                                        optionProps.className ||
                                                        ""
                                                    } px-2 py-1 flex items-center gap-2`}
                                                >
                                                    <Checkbox
                                                        icon={
                                                            <Iconify
                                                                icon={
                                                                    IconCode.unCheckBox
                                                                }
                                                                className="text-gray-400"
                                                            />
                                                        }
                                                        checkedIcon={
                                                            <Iconify
                                                                icon={
                                                                    IconCode.checkedBox
                                                                }
                                                                className="text-primary"
                                                            />
                                                        }
                                                        checked={selected}
                                                    />
                                                    {option.pName}
                                                </li>
                                            );
                                        }}
                                        className="max-w-96 w-full"
                                        value={selectedMembers[index]}
                                        onChange={(event, newValue) =>
                                            handleSelectChange(index, newValue)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                {...params}
                                                label="Select Members"
                                                placeholder="Add Patients"
                                            />
                                        )}
                                    />

                                    <div className="flex flex-row items-start gap-2">
                                        <CustomButton
                                            variant="contained"
                                            onClick={() =>
                                                handleAddClick(
                                                    index,
                                                    item,
                                                    cartInPatient?.centreId
                                                )
                                            }
                                        >
                                            Add
                                        </CustomButton>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            {!!open && (
                <ConfirmDialog
                    onClose={onClose}
                    open={!!open}
                    title={
                        <div className="flex flex-row items-center justify-between border-b border-gray-200 pb-4 -mx-4 px-4">
                            <h4 className="text-xl font-bold">Delete Test</h4>
                            <CustomIconButton onClick={onClose}>
                                <Iconify icon={IconCode.close} width={24} />
                            </CustomIconButton>
                        </div>
                    }
                    content={
                        <DeletePatientFromCartPopup
                            removeTest={removeTest}
                            open={open}
                            onClose={onClose}
                        />
                    }
                    maxWidth="md"
                    isCancel={true}
                />
            )}
        </>
    );
};

export default PatientAddedInCart;
